import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApplicationHttpClient } from 'src/app/shared/api/application-http-client';
import { IAIQuestionResponse, IAIRequest } from './ai-recognition-dialog.interface';

@Injectable()
export class AiRecognitionDialogService {

  constructor(private httpClient: ApplicationHttpClient){}

  sendToAI(studentTestId: number, aiData: IAIRequest): Observable<IAIQuestionResponse> {
    return this.httpClient.post<IAIQuestionResponse>(`/recognition/answer-multi/${studentTestId}`, aiData);
  }
}
